import React, { useState, useRef, useEffect } from "react";
import { Stage, Image, Layer, Rect, Text } from "react-konva";
import { shallowEqual, useSelector } from "react-redux";
import Polygon from "./Polygon";
import Abstacles from "./Abstacles";
import { addNewImage } from "../canvasFunction";
import {
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  handleMouseDown2,
  handleMouseMove2,
  handleMouseUp2,
} from "../DSFunction";
import { useDispatch } from "react-redux";
import AddImage from "./addImage";
import CursorLine from "./cursorLine";
import PolygonDraw from "./polygonDraw";
import Pointer from "./pointer";
import RoofDetail from "./roofDetail";
import AbstaclePointer from "./abstaclePointer";
import { xPoint, yPoint } from "./function";
import { addCustomizeImage } from "../structurePlacementFunction/customizeStructurePlacement";
import { addSmithStructure } from "../structurePlacementFunction/smithStructure";
import { structureAlignUsingKey } from "../Accordion/accordionFunction";

export default function Canvas({
  selectedImage,
  setSelectedImage,
  startPos,
  setStartPos,
  currentPos,
  setCurrentPos,
  isDrawing,
  setIsDrawing,
  zoomValue,
  setZoomValue,
  setDragPos,
  dragPos,
  drag,
  points,
  setPoints,
}) {
  const [image, setImage] = useState(null);
  const stageRef = useRef();
  const designParameter = useSelector((state) => state.designParameter);
  const gridInfo = useSelector((state) => state.grid);
  const roofInfo = useSelector((state) => state.roof, shallowEqual);
  const quantityInfo = useSelector((state) => state.quantity);
  const [cursorDistance, setCursorDistance] = useState(null);
  const dispatch = useDispatch();

  const boxDimension = roofInfo?.value?.boxDimension
    ? roofInfo.value.boxDimension
    : [];
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  const roofAbstacles = roofInfo?.value?.abstacles
    ? roofInfo.value.abstacles
    : [];

  const img = new window.Image();
  useEffect(() => {
    img.onload = () => {
      setImage(img);
    };
    // eslint-disable-next-line
  }, []);
  const imageSrc = useSelector((state) => state.img.ImageSrc);
  img.src = `${imageSrc}`;

  const handleAddImage = () => {
    if (gridInfo.addStructure) {
      const roofNo = quantityInfo.roofNo;
      const roofDetail = quantityInfo.roofData[roofNo];

      if (roofDetail.customizeStructure) {
        addCustomizeImage({
          dispatch,
          roofInfo,
          currentPos,
          quantityInfo,
          designParameter,
        });
      } else if (roofDetail.newStructure) {
        addSmithStructure({
          dispatch,
          roofInfo,
          currentPos,
          quantityInfo,
        });
      } else {
        addNewImage({
          dispatch,
          roofInfo,
          currentPos,
          quantityInfo,
        });
      }
    } else {
      return false;
    }
  };

  // eslint-disable-next-line
  const keydownHandler = (e) => {
    if (
      e.keyCode === 90 &&
      e.ctrlKey &&
      (designParameter.drawPolygon || designParameter.drawAbstacle)
    ) {
      const updatedPoints = [...points];
      updatedPoints.pop();
      setPoints(updatedPoints);
    }
    if (
      e.key === "ArrowUp" ||
      e.key === "ArrowDown" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight"
    ) {
      e.preventDefault();
      structureAlignUsingKey({
        e,
        dispatch,
        designParameter,
        quantityInfo,
        roofInfo,
        gridInfo,
      });
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keydownHandler);
    return () => {
      document.removeEventListener("keydown", keydownHandler);
    };
  }, [keydownHandler]);

  const handleWheel = (event) => {
    var specificPoint = stageRef.current.getPointerPosition();
    if (event.deltaY < 0) {
      if (zoomValue < 4) {
        setZoomValue(zoomValue + 0.075);
        let xx = specificPoint.x * 1 - specificPoint.x * (zoomValue + 0.075);
        let yy = specificPoint.y * 1 - specificPoint.y * (zoomValue + 0.075);
        setDragPos({ x: xx, y: yy });
      }
    } else {
      if (zoomValue > 1) {
        setZoomValue(zoomValue - 0.075);
        let xx = specificPoint.x * 1 - specificPoint.x * (zoomValue - 0.075);
        let yy = specificPoint.y * 1 - specificPoint.y * (zoomValue - 0.075);
        setDragPos({ x: xx, y: yy });
      }
    }
  };

  return (
    <>
      <div
        className="transform"
        style={{
          transformOrigin: "top left",
          transition: "all 0.5s ease",
        }}
        onWheel={(event) => handleWheel(event)}
        // onContextMenu={handleContextMenu}
      >
        {/* Set the draggable boundary of the following stage so it wont goes out of view */}
        <Stage
          style={drag ? { cursor: "grab" } : { cursor: "crosshair" }}
          width={boxDimension.width}
          height={boxDimension.height}
          ref={stageRef}
          draggable={drag}
          x={dragPos.x}
          y={dragPos.y}
          scale={{ x: zoomValue, y: zoomValue }}
          onClick={() => handleAddImage()}
          dragBoundFunc={(pos) => {
            const x = pos.x;
            const y = pos.y;
            setDragPos({ x, y });
            return pos;
          }}
          onMouseDown={(e) => {
            if (designParameter.drawAbstacle || designParameter.drawPolygon) {
              handleMouseDown({
                stageRef,
                designParameter,
                points,
                setPoints,
                setCurrentPos,
                cursorDistance,
                dragPos,
                zoomValue,
                dispatch,
                quantityInfo,
              });
            } else if (!drag) {
              handleMouseDown2(
                e,
                setIsDrawing,
                setStartPos,
                dragPos,
                zoomValue
              );
            }
          }}
          onMouseMove={(e) => {
            if (designParameter.drawAbstacle || designParameter.drawPolygon) {
              handleMouseMove({
                designParameter,
                stageRef,
                setCursorDistance,
                dragPos,
                zoomValue,
              });
            } else if (!drag) {
              handleMouseMove2(e, setCurrentPos, dragPos, zoomValue);
            }
          }}
          onMouseUp={(e) => {
            if (designParameter.drawAbstacle || designParameter.drawPolygon) {
              handleMouseUp({ setCurrentPos });
            } else if (!drag) {
              handleMouseUp2(
                setIsDrawing,
                startPos,
                currentPos,
                quantityInfo,
                setSelectedImage
              );
            }
          }}
        >
          <Layer>
            {image && (
              <Image
                image={image}
                width={boxDimension.width}
                height={boxDimension.height}
                scaleX={1}
                scaleY={1}
              />
            )}
            {roofInfo.value.mapOption.mapTypeId === "gridView" &&
              Array.from({ length: gridInfo.row }).map((_, rowIndex) =>
                Array.from({ length: gridInfo.column }).map((_, colIndex) => (
                  <Rect
                    key={`${rowIndex}-${colIndex}`}
                    x={colIndex * gridInfo.zoom}
                    y={rowIndex * gridInfo.zoom}
                    width={gridInfo.zoom}
                    height={gridInfo.zoom}
                    stroke="lightgray"
                    fill="white"
                    strokeWidth={1}
                  />
                ))
              )}
            {(designParameter.drawPolygon || designParameter.drawAbstacle) &&
              dragPos && (
                <>
                  <PolygonDraw points={points} />
                  <CursorLine
                    cursorDistance={cursorDistance}
                    points={points}
                  ></CursorLine>
                </>
              )}
            {roofPolygons &&
              roofPolygons.map((polygon, index) => (
                <React.Fragment key={index}>
                  <Polygon
                    key={index}
                    index={index}
                    points={polygon.updatedPoints}
                    stageRef={stageRef}
                    dragPos={dragPos}
                    zoomValue={zoomValue}
                  />
                  <Text
                    x={xPoint(polygon.updatedPoints) - 25}
                    y={yPoint(polygon.updatedPoints) - 20}
                    text={`Roof ${index + 1}`}
                    fontFamily="italic"
                    fill="blue"
                    fontSize={18}
                    strokeWidth={2}
                  />
                </React.Fragment>
              ))}
            {roofPolygons.length > 0 && (
              <>
                <Pointer
                  stageRef={stageRef}
                  dragPos={dragPos}
                  zoomValue={zoomValue}
                  setIsDrawing={setIsDrawing}
                />
              </>
            )}

            {roofAbstacles &&
              roofAbstacles.map((abstacles, index) => (
                <Abstacles
                  key={index}
                  points={abstacles.updatedPoints}
                  index={index}
                  stageRef={stageRef}
                  dragPos={dragPos}
                  zoomValue={zoomValue}
                />
              ))}

            {roofAbstacles.length > 0 && (
              <AbstaclePointer
                stageRef={stageRef}
                dragPos={dragPos}
                zoomValue={zoomValue}
                setIsDrawing={setIsDrawing}
              />
            )}

            {isDrawing &&
              !designParameter.drawAbstacle &&
              !designParameter.drawPolygon && (
                <Rect
                  x={startPos.x}
                  y={startPos.y}
                  width={currentPos.x - startPos.x}
                  height={currentPos.y - startPos.y}
                  stroke="blue"
                  fill="rgba(0, 0, 255, 0.2)"
                />
              )}
            {quantityInfo.roofData && (
              <RoofDetail
                setSelectedImage={setSelectedImage}
                selectedImage={selectedImage}
                drag={drag}
              ></RoofDetail>
            )}
            {gridInfo.addStructure && (
              <AddImage currentPos={currentPos}></AddImage>
            )}
          </Layer>
        </Stage>
      </div>
    </>
  );
}
